import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Visit } from "./Visit.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'AccessCard'
})
export class AccessCard extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({ maxLength: 50 })
  iD_SP!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_POS!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  isRevoked: boolean = false;

  fK_CurrentVisit?: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Visit })
    currentVisit?: Visit;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  GetType(): IEntityMetaData {
    return AccessCard.getMetaData();
  }
}
